import '@main';
import '@vendor/swiper/swiper-bundle.min.js';

u.importCSS('@vendor/swiper/swiper-bundle.min.css');

const awakeningSwiper = new Swiper(".j-awakening-swiper", {
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  slidesPerView: 1,
  spaceBetween: 30,
  pagination: {
    el: ".j-awakening-swiper-pagination",
  },
  breakpoints: {
    768: {
      slidesPerView: 2,
    },
    1200: {
      slidesPerView: 3,
    },
  }
});

// announcements
const articleSwiper = new Swiper(".j-article-swiper", {
  slidesPerView: 1,
  navigation: {
    nextEl: ".j-article-swiper-button-next",
    prevEl: ".j-article-swiper-button-prev",
  },
  pagination: {
    el: ".j-article-pagination-progressbar",
    type: "progressbar",
  },
});

const articleNumberSwiper = new Swiper(".j-article-swiper", {
  spaceBetween: 30,
  pagination: {
    el: ".j-article-pagination-number",
    type: "fraction",
  },
});

articleSwiper.controller.control = articleNumberSwiper;
